import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface InfoRowProps {
  label?: string;
  value?: React.ReactNode;
  icon?: LucideIcon;
  badge?: React.ReactNode;
  muted?: boolean;
  className?: string;
}

export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  icon: Icon,
  badge,
  muted = false,
  className,
}) => {
  return (
    <div
      data-testid={`info-row-${label?.toLowerCase().replace(/\s+/g, '-')}`}
      className={cn(
        'flex items-center justify-between py-2.5',
        'border-b border-slate-100 dark:border-slate-800 last:border-0',
        className
      )}
    >
      <div className="flex items-center gap-2">
        {Icon && (
          <Icon
            className="w-4 h-4 text-slate-400 dark:text-slate-500"
            strokeWidth={1.5}
          />
        )}
        <span className="text-sm text-slate-500 dark:text-slate-400">
          {label}
        </span>
      </div>
      <div className="flex items-center gap-2">
        {badge ? (
          badge
        ) : (
          <span
            className={cn(
              'text-sm font-medium',
              muted
                ? 'text-slate-400 dark:text-slate-500'
                : 'text-slate-900 dark:text-slate-100'
            )}
          >
            {value}
          </span>
        )}
      </div>
    </div>
  );
};
